import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Building2, X } from 'lucide-react';

interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

const navigation = [
  { name: 'Dashboard', href: '/', icon: LayoutDashboard },
  { name: 'Clientes', href: '/clientes', icon: Building2 },
];

const SidebarContent: React.FC = () => (
  <div className="flex flex-col h-full">
    <div className="flex items-center gap-3 px-6 py-5 border-b border-gray-700">
      <img
        src="/images/icon_logo.svg"
        alt="SwimmingPool"
        className="h-8 w-8"
        onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
      />
      <div>
        <span className="text-lg font-bold text-white">SwimmingPool</span>
        <span className="block text-xs text-gray-400 font-medium tracking-wider">MASTER</span>
      </div>
    </div>

    <nav className="flex-1 px-3 py-4 space-y-1">
      {navigation.map((item) => (
        <NavLink
          key={item.name}
          to={item.href}
          end={item.href === '/'}
          className={({ isActive }) =>
            `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
              isActive
                ? 'bg-primary-600 text-white'
                : 'text-gray-300 hover:bg-gray-700 hover:text-white'
            }`
          }
        >
          <item.icon className="h-5 w-5 flex-shrink-0" />
          {item.name}
        </NavLink>
      ))}
    </nav>

    <div className="px-4 py-4 border-t border-gray-700">
      <p className="text-xs text-gray-500 text-center">
        SwimmingPool Master v1.0
      </p>
    </div>
  </div>
);

const Sidebar: React.FC<SidebarProps> = ({ isOpen, onClose }) => {
  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 z-40 bg-black/50 lg:hidden" onClick={onClose} />
      )}

      <div
        className={`fixed inset-y-0 left-0 z-50 w-64 bg-gray-900 transform transition-transform duration-300 lg:translate-x-0 ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        } lg:z-30`}
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-white lg:hidden"
        >
          <X className="h-5 w-5" />
        </button>
        <SidebarContent />
      </div>
    </>
  );
};

export default Sidebar;

